export default __webpack_public_path__ + "static/media/3380.5f6e452d.png";